import styled from 'styled-components'

export const Wrapper = styled.div<{ $backgroundColor?: string; $boxShadow?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  background: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme.colors.grey50};
  box-shadow: ${({ theme, $boxShadow }) => $boxShadow ?? `${theme.colors.indigoShadow} 0px 0px 10px 1px`};
  padding: 16px;
  height: 80px;
  justify-content: space-between;
`

export const LogoImgDiv = styled.a`
  width: 200px;
`;

export const LogoImg = styled.img<{ customLogoWidth?: string; customLogoHeight?: string }>`
  width: ${({ customLogoWidth, customLogoHeight }) => customLogoHeight ? 'auto' : (customLogoWidth ?? '120px')};
  height: ${({ customLogoHeight }) => customLogoHeight ?? 'auto'};
`;

export const WrapperRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: flex-end;
`

export const WrapperInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media screen and (max-width: 576px) {
    display: none;
  }
`

export const Info = styled.p<{ $textColor?: string, $textSizeWellcomeMessage?: string, $textCompanyName?: boolean }>`
  margin: 0;
  color: ${({ theme, $textColor }) => $textColor ?? theme.colors.grey600};
  font-size: ${({ $textSizeWellcomeMessage }) => $textSizeWellcomeMessage ?? '14px'};
  font-weight: ${({ $textCompanyName }) => $textCompanyName ? '400' : '500'};
`;

export const UserImage = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  align-self: center;
  object-fit: cover;
`;

export const LogoutContent = styled.div<{ $textColor?: string; $borderColor?: string }>`
  display: flex;
  justify-content: center;
  height: 50px;
  border-left: 1px solid ${({ theme, $borderColor }) => $borderColor ?? theme.colors.grey600};
  padding-left: 1.5em;
  padding-right: 1.5em;
  cursor: pointer;
  color: ${({ theme, $textColor }) => $textColor ?? theme.colors.grey600};
  position: relative;
  align-items: center;
`;

export const LogoutTooltip = styled.span`
  position: absolute;
  top: calc(100% + 24px);
  left: 20%;
  transform: translateX(-50%);
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  font-size: 14px;
  font-weight: 400;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  pointer-events: none;
  border: none;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

  ${LogoutContent}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

export const MenuWrapper = styled.div`
  position: relative;
`

export const ChevronButton = styled.button<{ $isOpen?: boolean; $textColor?: string }>`
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme, $textColor }) => $textColor ?? theme.colors.grey600};
  padding: 4px 8px;
  display: flex;
  align-items: center;

  svg {
    transition: transform 0.5s;
    transform: ${({ $isOpen }) => $isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  }

  ${MenuWrapper}:hover & svg {
    transform: rotate(180deg);
  }
`

export const DropdownMenu = styled.div<{ $isOpen?: boolean }>`
  position: absolute;
  top: calc(50% + 48px);
  right: 0;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  min-width: 160px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  opacity: ${({ $isOpen }) => $isOpen ? 1 : 0};
  transform: ${({ $isOpen }) => $isOpen ? 'translateY(0px)' : 'translateY(30px)'};
  visibility: ${({ $isOpen }) => $isOpen ? 'visible' : 'hidden'};
  pointer-events: ${({ $isOpen }) => $isOpen ? 'auto' : 'none'};
  transition: all linear 0.7s;

  ${MenuWrapper}:hover & {
    opacity: 1;
    transform: translateY(0px);
    visibility: visible;
    pointer-events: auto;
  }
`

export const DropdownItem = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primaryLight};
  }
`